import { FormControl, MenuItem, Select } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import React from "react";
import { useDispatch } from "react-redux";
import { menuValue, studyValue } from "../../../redux/Reducer/DataSlice";
import { SearchAddDiv } from "../../style/Table.style";
import useProfile from "../../../hooks/useProfile";

const UserLevelFilter = () => {
  const dispatch = useDispatch();
  const [userData] = useProfile();

  const {
    refetch,
    isLoading,
    isError,
    error,
    isSuccess,
    data: LevelInfo = [],
  } = useQuery({
    queryKey: ["LevelInfo"],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/levelList/${userData?.id}`
      );
      const data = await res.json();
      return data;
    },
  });

  // console.log("LevelInfo", LevelInfo);

  const handleChange = (event) => {
    dispatch(menuValue(event.target.value));
    // refetch();
  };
  return (
    <div>
      <SearchAddDiv>
        <div
          style={{
            color: "#14a0de",
            fontSize: "x-large",
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          User Level Name .
          <span>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                // value={age}
                // defaultValue={studyData}
                onChange={handleChange}
              // label="Age"
              >
                {LevelInfo.map((userLevel) => (
                  <MenuItem
                    key={Math.random()}
                    // key={sponsor.sponsor_id}
                    value={userLevel.ug_level_id}
                  >
                    {userLevel.ugleve_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </span>
        </div>
      </SearchAddDiv>
    </div>
  );
};

export default UserLevelFilter;
